import "./ProfileDetailsLayoutComponent.scss";
import CardComponent from "../../../shared/components/card/CardComponent";
import ProfileBasicDetailsCardComponent from "../profile-basic-details-card/ProfileBasicDetailsCardComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import SubMenuListComponent from "../../../shared/components/sub-menu-list/SubMenuListComponent";
import {Outlet} from "react-router-dom";
import {CommonService} from "../../../shared/services";

interface ProfileDetailsLayoutComponentProps {

}

// const ClientDetailsSteps: any[] = ["basicDetails", "medicalHistoryQuestionnaire", "accountDetails"];
const ProfileDetailsLayoutComponent = (props: ProfileDetailsLayoutComponentProps) => {
    const {clientBasicDetails} = useSelector((state: IRootReducerState) => state.client);
    // const navigate = useNavigate();

    const PROFILE_MENU_ITEMS = [
        {
            title: "Profile Details",
            path: CommonService._routeConfig.ProfileDetails(),
        },
        {
            title: "Medical Questionnaire",
            path: CommonService._routeConfig.ProfileMedicalHistoryDetails()
        },
        {
            title: "Preferences",
            path: CommonService._routeConfig.ProfilePreferencesDetails()
        },
        {
            title: "Link/Unlink Profile",
            path: CommonService._routeConfig.ProfileLinking(),
        },
    ];

    // useEffect(() => {
    //     setCurrentTab(null);
    //     if (location.pathname.match('/profile/details')) {
    //         let currentTab: any = searchParams.get("currentStep");
    //         if (currentTab) {
    //             if (!ClientDetailsSteps.includes(currentTab)) {
    //                 currentTab = "basicDetails";
    //             }
    //         } else {
    //             currentTab = "basicDetails";
    //         }
    //         setCurrentTab(currentTab);
    //     } else {
    //         setCurrentTab("accountsICanAccess");
    //     }
    // }, [searchParams, location]);


    // const navigateToEdit = useCallback(() => {
    //     if (currentTab === "basicDetails") {
    //         navigate(CommonService._client.NavigateToClientEdit("basicDetails"));
    //     } else {
    //         navigate(CommonService._client.NavigateToClientEdit("accountDetails"));
    //     }
    // }, [navigate, currentTab]);

    return (
        <div className={'' +
            'profile-details-layout-component'}>
            <div className="profile-details-layout-body-component">
                {/*<CardComponent>*/}
                <div className="ts-row">
                    <div className="ts-col-lg-3 ts-col-md-12 ts-col-sm-6 side-menu-holder">
                        <ProfileBasicDetailsCardComponent currentUser={clientBasicDetails}/>
                        <div className={"client-details-sub-menu-holder"}>
                            <SubMenuListComponent menuItems={PROFILE_MENU_ITEMS}/>
                        </div>
                    </div>

                    <CardComponent className="pdd-left-0 ts-col-lg-9 ts-col-md-12 ts-col-sm-12 outlet">
                        <Outlet/>
                    </CardComponent>

                </div>
                {/*</CardComponent>*/}
            </div>
        </div>
    );

};

export default ProfileDetailsLayoutComponent;
